import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../core';
import { ClassificacaoAgrupamentoPorTipoClassificacao } from '../classificacao-agrupamento-por-tipo-classificacao';
import { ClassificacaoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class ClassificacaoAgrupamentoHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                private configServerService: ConfigServerService) {
        this.pathApi = `${this.configServerService.getPathApi()}/classificacao/0/agrupamento`
    }

    /** Pesquisa as classificações agrupadas pelo seu tipo de classificação */
    searchAgrupamentoPorTipoClassificacao(filter: ClassificacaoFilter): Observable<ClassificacaoAgrupamentoPorTipoClassificacao[]> {
        // Params
        let params = new HttpParams();
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ClassificacaoAgrupamentoPorTipoClassificacao[]>(`${this.pathApi}/tipoclassificacao`, {params});
    }
}
